import Vue from 'vue'
import ReactiveProvide from 'vue-reactive-provide'

Vue.use(ReactiveProvide)

Vue.use(ReactiveProvide, {
	name: 'reactiveProvide'
})
